{
  "required": "Nécessaire",
  "must_be_less_than": "Doit contenir {{ characters }} caractères ou moins",
  "problem_with_our_servers": "Un problème est survenu avec nos serveurs. Veuillez réessayer ultérieurement.",
  "problem_with_our_servers_code": "Un problème est survenu avec nos serveurs. Le code d'erreur est {{ code }}",
  "problem_with_data_submitted": "Un problème est survenu avec les données soumises au serveur",
  "connecting_with_our_servers": "Un problème est survenu lors de la connexion à nos serveurs. Veuillez réessayer ultérieurement.",
  "timeout_connecting_servers": "Le délai imparti pour votre demande a expiré. Veuillez réessayer.",
  "internet_connection_issue": "Il y a un problème de connexion au serveur. Vérifiez votre connexion Internet",
  "copy_code": "Copier le code",
  "polygon_edit_error": "Les polygones doivent avoir au moins 3 nœuds",
  "linestring_edit_error": "Les lignes doivent avoir au moins 2 nœuds",
  "unknown_edit_error": "Une erreur inconnue s'est produite",
  "billing_error": "Un problème est survenu lors de la facturation de votre projet",
  "service_unavailable": "Ce service n'est pas disponible actuellement, veuillez contacter un administrateur du projet",
  "three_nested": "Vous ne pouvez pas créer un dossier de plus de 3 niveaux de profondeur",
  "error": "Erreur",
  "invalidLink": "Lien non valide",
  "error_boundaries": {
    "title_large": "Oups ! Quelque chose s'est mal passé.",
    "title_small": "Quelque chose s'est mal passé !",
    "error_message": "Quelque chose ne va pas et notre équipe a été alertée. Si le problème persiste, contactez le support au ",
    "error_code": "Code d'erreur : {{ code }}",
    "contact": "Nous contacter",
    "refresh": "Actualiser",
    "reload": "Recharger",
    "webgl_error_title": "Erreur WebGL détectée",
    "webgl_error_message": "Votre navigateur ou votre appareil ne prend pas en charge WebGL, qui est nécessaire pour consulter ce plan.",
    "webgl_support_message": "Vous trouverez peut-être des conseils sur l'activation de WebGL ici : ",
    "webgl_error_contact": "Si le problème persiste, contactez le support à ",
    "version_error_title": "Une nouvelle version d'Iventis est disponible",
    "version_error_message": "Veuillez actualiser votre navigateur pour charger la dernière version d'Iventis.",
    "connection_error_title": "Erreur de connexion",
    "connection_error_message": "Un problème est survenu avec votre connexion. Vérifiez votre connexion Internet et réessayez."
  },
  "digital_twin": {
    "capacity": "Capacité de serveur insuffisante pour le jumeau numérique. Veuillez réessayer ultérieurement, ou contactez {{ supportEmail }} pour plus d'informations",
    "occupied": "Le jumeau numérique est actuellement occupé. Veuillez réessayer ultérieurement.",
    "afk": "Vous avez été déconnecté du jumeau numérique pour cause d'inactivité.",
    "connection_failed": "Impossible de se connecter au service de jumeau numérique. Veuillez réessayer ultérieurement.",
    "generic": "Un problème est survenu avec le service de jumeau numérique. Veuillez réessayer ultérieurement."
  },
  "custom_network_error": {
    "create": {
      "title": "Impossible de créer {{ entity }}",
      "message": "La création de {{ entity }} n'a pas été enregistrée"
    },
    "update": {
      "title": "Impossible de mettre à jour {{ entity }}",
      "message": "Vos modifications apportées à l' {{ entity }} n'ont pas été enregistrées"
    },
    "import_error": {
      "title": "Impossible d'importer {{ entity }}",
      "message": "Votre {{ entity }} n'a pas été importée"
    },
    "export_error": {
      "title": "Impossible d'exporter {{ entity }}",
      "message": "Votre {{ entity }} n'a pas été exportée"
    },
    "delete_error": {
      "title": "Impossible de supprimer {{ entity }}",
      "message": "Votre {{ entity }} n'a pas été supprimée"
    },
    "generic": {
      "title": "Impossible de {{ action }}",
      "message": "Votre demande à {{ action }} n'a pas été acceptée"
    }
  }
}